/**
 * Central exports for routing utilities
 * Provides a clean public API for all routing functionality
 */

export type { RouteDefinition, SiteData, PageData } from "./types";

export {
  getBaseUrl,
  getRoutes,
  routesBySiteType,
  defaultRouteBySiteType,
  isSiteStylesRoute,
  siteStylesRouteNames,
  siteStylesRoutes,
} from "./dashboardRoutes";

export type { SiteStylesRouteName } from "./dashboardRoutes";

export { createRoutes } from "./websiteRoutes";

export { default as unauthenticatedRoutes } from "./unauthenticatedRoutes";

export {
  buildRouteMaps,
  buildPathWithParams,
  matchPathToRouteName,
} from "./routeHelpers";

export type { RouteMaps } from "./routeHelpers";

export { RouteMapContext, RouteMapProvider } from "./RouteMapContext";

export type { RouteMapContextValue } from "./RouteMapContext";

export { RouterSetup } from "./RouterSetup";
export { RouterTestSetup } from "./RouterTestSetup";
export { EnforceDefaultQueryParams } from "./EnforceDefaultQueryParams";

export {
  useRouteInfo,
  useRouterNavigation,
  useBuildUrl,
  useRouteActive,
} from "./routingHooks";

export type {
  RouteInfo,
  NavigateToFunction,
  BuildUrlFunction,
  RouteActiveFunction,
} from "./routingHooks";

export { withInvalidRouteRedirect } from "./withInvalidRouteRedirect";
